/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Notification_Nonetocopy4Inputs */

const id_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada kunci API untuk disalin`)
};

const ms_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada kunci API untuk disalin`)
};

const da_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API nøgle at kopiere`)
};

const de_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein API-Schlüssel zum Kopieren vorhanden`)
};

const en_us2_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

const es_es2_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay clave de API para copiar`)
};

const es_mx2_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay API key para copiar`)
};

const fil_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang API key na kopyahin`)
};

const fr_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune clé API à copier`)
};

const it_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna chiave API da copiare`)
};

const hu_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs API kulcs másolni`)
};

const nl_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen API-sleutel om te kopiëren`)
};

const no_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API-nøkkel å kopiere`)
};

const pl_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak klucza API do skopiowania`)
};

const pt_br2_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

const pt_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma chave de API para copiar`)
};

const ro_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicio cheie API de copiat`)
};

const fi_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei API-avainta kopioitavaksi`)
};

const sv_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API-nyckel att kopiera`)
};

const vi_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có khóa API để sao chép`)
};

const tr_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyalanacak API anahtarı yok`)
};

const cs_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný API klíč ke kopírování`)
};

const bg_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма API ключ за копиране`)
};

const ru_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет API-ключа для копирования`)
};

const uk_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає API-ключа для копіювання`)
};

const ar_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد مفتاح API للنسخ`)
};

const hi_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी करने के लिए कुछ नहीं`)
};

const th_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีคีย์ API ให้คัดลอก`)
};

const ja_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーする API キーがありません`)
};

const zh_cn2_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

const zh_hant1_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

const ko_components_apikeymanager_notification_nonetocopy4 = /** @type {(inputs: Components_Apikeymanager_Notification_Nonetocopy4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API key to copy`)
};

/**
* | output |
* | --- |
* | "No API key to copy" |
*
* @param {Components_Apikeymanager_Notification_Nonetocopy4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_notification_nonetocopy4 = /** @type {((inputs?: Components_Apikeymanager_Notification_Nonetocopy4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Notification_Nonetocopy4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "ms") return ms_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "da") return da_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "de") return de_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "fil") return fil_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "fr") return fr_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "it") return it_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "hu") return hu_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "nl") return nl_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "no") return no_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "pl") return pl_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "pt") return pt_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "ro") return ro_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "fi") return fi_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "sv") return sv_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "vi") return vi_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "tr") return tr_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "cs") return cs_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "bg") return bg_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "ru") return ru_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "uk") return uk_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "ar") return ar_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "hi") return hi_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "th") return th_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "ja") return ja_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_notification_nonetocopy4(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_notification_nonetocopy4(inputs)
	return ko_components_apikeymanager_notification_nonetocopy4(inputs)
});
export { components_apikeymanager_notification_nonetocopy4 as "components.apiKeyManager.notification.noneToCopy" }